var colors = {
  getColorByID: function(id){
    var result;
    this.all.forEach(function(color){
      if (color.id == id) {result=color;}
    })
    return result;
  },
  getColorByName: function(name){
    var result;
    this.all.forEach(function(color){
      if (color.name == name) {result=color;}
    })
    return result;
  },
  getRandomColor: function(){
    return this.all[Math.floor(Math.random() * this.all.length)];
  },
  all: [
    {
      id: 'M1801',
      name: 'White',
      light: '#FFFFFF',
      dark: '#EAEAEA'
    },
    {
      id: 'I0020',
      name: 'Black',
      light: '#34393D',
      dark: '#060707'
    },
    {
      id: 'I4113',
      name: 'Alexis Blue',
      light: '#4BAFD9',
      dark: '#3A9ECA'
    },
    {
      id: 'M1613',
      name: 'Silver',
      light: '#A0B3BF',
      dark: '#7C8E9B'
    },
    {
      id: 'I0933',
      name: 'Brown',
      light: '#805742',
      dark: '#5B3927'
    },
    {
      id: 'I2220',
      name: 'Tropicana',
      light: '#F07A95',
      dark: '#DB5C74'
    },
    {
      id: 'I3761',
      name: 'Winter Sky',
      light: '#9BB6CB',
      dark: '#7594AE'
    },
    {
      id: 'I0800',
      name: 'Golden Rod',
      light: '#EF9D1C',
      dark: '#DF840F'
    },
    {
      id: 'I1903',
      name: 'True Red',
      light: '#DC4443',
      dark: '#BC302E'
    },
    {
      id: 'I0761',
      name: 'Oat',
      light: '#BEB397',
      dark: '#A89C80'
    },
    {
      id: 'I5515',
      name: 'Kelly Green',
      light: '#3D9866',
      dark: '#23794D'
    },
    {
      id: 'I1703',
      name: 'Scarlet',
      light: '#EA5341',
      dark: '#CC3929'
    },
    {
      id: 'I3611',
      name: 'Blue Ribbon',
      light: '#4875D3',
      dark: '#3058AF'
    },
    {
      id: 'I0220',
      name: 'Sunbeam',
      light: '#D7CC42',
      dark: '#C3B729'
    },
    {
      id: 'I5326',
      name: 'Evergreen',
      light: '#395E52',
      dark: '#203E35'
    },
    {
      id: 'I2905',
      name: 'Dark Purple',
      light: '#7A65BC',
      dark: '#533F8D'
    },
    {
      id: 'I3344',
      name: 'Midnight Blue',
      light: '#3E4558',
      dark: '#262C39'
    },
    {
      id: 'I2830',
      name: 'Light Purple',
      light: '#A38BC9',
      dark: '#8A71B2'
    },
    {
      id: 'I2508',
      name: 'Fuschia',
      light: '#DD66B3',
      dark: '#CA5096'
    },
    {
      id: 'I1950',
      name: 'Hot Pink',
      light: '#FF6C83',
      dark: '#EF5266'
    },
    {
      id: 'I1532',
      name: 'Coral',
      light: '#F6A597',
      dark: '#E58777'
    },
    {
      id: 'I6010',
      name: 'Neon Yellow',
      light: '#D5E822',
      dark: '#BFD903'
    },
    {
      id: 'I1102',
      name: 'Orange',
      light: '#F78042',
      dark: '#E6652B'
    },
    {
      id: 'I4410',
      name: 'Dark Teal',
      light: '#3197AE',
      dark: '#19768B'
    },
    {
      id: 'I5500',
      name: 'Neon Green',
      light: '#74D25A',
      dark: '#57BF48'
    },
    {
      id: 'I5934',
      name: 'Army Green',
      light: '#6B792C',
      dark: '#475314'
    },
    {
      id: 'I4220',
      name: 'Light Teal',
      light: '#5BBBCC',
      dark: '#40A4B7'
    },
    {
      id: 'I3732',
      name: 'Navy Blue',
      light: '#365C85',
      dark: '#234164'
    },
    {
      id: 'I5830',
      name: 'French Lime',
      light: '#A2D16D',
      dark: '#85BA55'
    },
    {
      id: 'I4074',
      name: 'Dark Grey',
      light: '#73848D',
      dark: '#5C6B74'
    },
    {
      id: 'I2363',
      name: 'Baby Pink',
      light: '#E1BFCD',
      dark: '#D5AABA'
    },
    {
      id: 'I3962',
      name: 'Baby Blue',
      light: '#88C5E7',
      dark: '#70AFD6'
    },
    {
      id: 'I2704',
      name: 'Dark Magenta',
      light: '#934194',
      dark: '#75286E'
    },
    {
      id: 'I2113',
      name: 'Cranberry',
      light: '#873E48',
      dark: '#63262E'
    },
    {
      id: 'I0605',
      name: 'Daisy Yellow',
      light: '#EFBA10',
      dark: '#E4A606'
    },
    {
      id: 'I2152',
      name: 'Dusty Rose',
      light: '#D897A9',
      dark: '#C17C90'
    },
    {
      id: 'I1106',
      name: 'Neon Orange',
      light: '#FF7E46',
      dark: '#FF7139'
    },
    {
      id: 'I5650',
      name: 'Pastel Green',
      light: '#B0C9A1',
      dark: '#9DB88D'
    },
    {
      id: 'I1306',
      name: 'Neon Scarlet',
      light: '#FF694D',
      dark: '#FF5635'
    },
    {
      id: 'I0731',
      name: 'Rye',
      light: '#C3A25B',
      dark: '#AF8943'
    },
    {
      id: 'I0842',
      name: 'Capuchino',
      light: '#C0915A',
      dark: '#A67540'
    },
    {
      id: 'I1141',
      name: 'Chocolate Milk',
      light: '#C4A283',
      dark: '#B08A6B'
    },
    {
      id: 'I0904',
      name: 'Pumpkin',
      light: '#E5882D',
      dark: '#D7731D'
    },
    {
      id: 'I5531',
      name: 'Lime Green',
      light: '#6EA962',
      dark: '#58944D'
    },
    {
      id: 'I5513',
      name: 'Slime Green',
      light: '#4AA14C',
      dark: '#318135'
    },
    {
      id: 'I0270',
      name: 'Ivory',
      light: '#D5D0B0',
      dark: '#C4BC91'
    },
    {
      id: 'M1692',
      name: 'Aquamarine',
      light: '#9ECBD4',
      dark: '#84B2BB'
    },
    {
      id: 'M1610',
      name: 'Light Silver',
      light: '#BCC8D1',
      dark: '#A0ADB7'
    },
    {
      id: 'M1360',
      name: 'Steel',
      light: '#88A9C2',
      dark: '#6A89A1'
    },
    {
      id: 'M1775',
      name: 'Slate Blue',
      light: '#6599CF',
      dark: '#4879B1'
    },
    {
      id: 'M1538',
      name: 'Tiramisu',
      light: '#BDA475',
      dark: '#9D8357'
    },
    {
      id: 'M1670',
      name: 'Vegas Gold',
      light: '#DDB96F',
      dark: '#C09B57'
    },
    {
      id: 'M1791',
      name: 'Pea Soup',
      light: '#C58D4D',
      dark: '#AB7235'
    },
    {
      id: 'M1779',
      name: 'Sweet Potato',
      light: '#DD6958',
      dark: '#C25141'
    },
    {
      id: 'M1821',
      name: 'Terra Cotta',
      light: '#D25641',
      dark: '#AE3C29'
    },
    {
      id: 'M1789',
      name: 'Plum',
      light: '#785275',
      dark: '#533550'
    },
    {
      id: 'M1706',
      name: 'Guacamole',
      light: '#96973F',
      dark: '#7C7B29'
    },
    {
      id: 'M1900',
      name: 'Celadon',
      light: '#A4C4AA',
      dark: '#87A78E'
    },
    {
      id: 'M1073',
      name: 'Winter Mint',
      light: '#BDC9B9',
      dark: '#9DA99B'
    },
    {
      id: 'M1595',
      name: 'Neon Pink',
      light: '#FF6C92',
      dark: '#FF546E'
    },
    {
      id: 'M1773',
      name: 'Autumn Gold',
      light: '#AA6422',
      dark: '#84450F'
    },
    {
      id: 'M1673',
      name: 'Khaki',
      light: '#BEA26A',
      dark: '#A0824D'
    },
    {
      id: 'M1672',
      name: 'Toasted Almond',
      light: '#B68F3A',
      dark: '#997224'
    },
    {
      id: 'M1392',
      name: 'Sage',
      light: '#879F8F',
      dark: '#677C6F'
    },
    {
      id: 'M1578',
      name: 'Faded Jade',
      light: '#8FB4AE',
      dark: '#6F9591'
    },
    {
      id: 'M1668',
      name: 'Silver Sage',
      light: '#5D6F5D',
      dark: '#425143'
    },
    {
      id: 'M1799',
      name: 'Green Turquoise',
      light: '#58CCCD',
      dark: '#3CB1B0'
    },
    {
      id: 'M1218',
      name: 'Apple Cider',
      light: '#CC9080',
      dark: '#AC7264'
    },
    {
      id: 'M1217',
      name: 'Cantaloupe',
      light: '#EBC2A8',
      dark: '#CE9E84'
    }
  ]
} 